export const answerMapping = {
   "111":{
      "products":[
         {
            "sku":"75001100000",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"74784800000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75073800001",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75161800000",
            "sceneId":"614a6a668135ae99e7eb653e"
         }
      ]
   },
   "131":{
      "products":[
         {
            "sku":"75072600000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75163300000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"99913600000",
            "sceneId":"614a6a668135ae99e7eb653e"
         }
      ]
   },
   "121":{
      "products":[
         {
            "sku":"75188500001",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"74851516060",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75004000000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"70910900000",
            "sceneId":"61773f0a64cca322c1f89d54"
         }
      ]
   },
   "113":{
      "products":[
         {
            "sku":"75163300000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"99895200000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"51483400000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75163500000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         }
      ]
   },
   "133":{
      "products":[
         {
            "sku":"75069716045",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"70910900000",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75003600000",
            "sceneId":"61773f0a64cca322c1f89d54"
         }
      ]
   },
   "123":{
      "products":[
         {
            "sku":"75034700000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75112216065",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"70910900000",
            "sceneId":"61773f0a64cca322c1f89d54"
         }
      ]
   },
   "112":{
      "products":[
         {
            "sku":"74784800000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"99914200000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75121300080",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75002264052",
            "sceneId":"614a6a668135ae99e7eb653e"
         }
      ]
   },
   "132":{
      "products":[
         {
            "sku":"75084716040",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"75036100000",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"74784800000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"99895200000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "122":{
      "products":[
         {
            "sku":"75103716050",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"74878200000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"99893600000",
            "sceneId":null
         }
      ]
   },
   "211":{
      "products":[
         {
            "sku":"75157700000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"75034500009",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"72992600000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"75068800000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "231":{
      "products":[
         {
            "sku":"72992600000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"75032300002",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"74947004060",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75002900000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "221":{
      "products":[
         {
            "sku":"75033700002",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75071300048",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"74522119080",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75020100095",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         }
      ]
   },
   "213":{
      "products":[
         {
            "sku":"75035200000",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"70910900000",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75020100095",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         }
      ]
   },
   "233":{
      "products":[
         {
            "sku":"70910900000",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75020100095",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"75078600001",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75148917065",
            "sceneId":"614a6a668135ae99e7eb653e"
         }
      ]
   },
   "223":{
      "products":[
         {
            "sku":"75091939048",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"74217419075",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"74895100000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"74965300000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "212":{
      "products":[
         {
            "sku":"75019400095",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"74824700000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "232":{
      "products":[
         {
            "sku":"75157700000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"74947004060",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"99911100000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"74824700000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "222":{
      "products":[
         {
            "sku":"74895100000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"75019400095",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75032300002",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75051219065",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         }
      ]
   },
   "311":{
      "products":[
         {
            "sku":"75034500009",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75068800000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75161800000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75073800001",
            "sceneId":"614a6a668135ae99e7eb653e"
         }
      ]
   },
   "331":{
      "products":[
         {
            "sku":"75072600000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"99913600000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"74947004060",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75002900000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "321":{
      "products":[
         {
            "sku":"74851516060",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75188500001",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75033700002",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"74522119080",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         }
      ]
   },
   "313":{
      "products":[
         {
            "sku":"75163500000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"51483400000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75019400095",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"74963500000",
            "sceneId":null
         }
      ]
   },
   "333":{
      "products":[
         {
            "sku":"70910900000",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75078600001",
            "sceneId":"61773f0a64cca322c1f89d54"
         },
         {
            "sku":"75069716045",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"75003600000",
            "sceneId":"61773f0a64cca322c1f89d54"
         }
      ]
   },
   "323":{
      "products":[
         {
            "sku":"75091939048",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"74217419075",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75034700000",
            "sceneId":"614a6aa5d7bb008cbec58ca9"
         },
         {
            "sku":"75112216065",
            "sceneId":"61773f0a64cca322c1f89d54"
         }
      ]
   },
   "312":{
      "products":[
         {
            "sku":"99914200000",
            "sceneId":"614a6a668135ae99e7eb653e"
         }
      ]
   },
   "332":{
      "products":[
         {
            "sku":"75157700000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"99911100000",
            "sceneId":"614a6a668135ae99e7eb653e"
         },
         {
            "sku":"75084716040",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         }
      ]
   },
   "322":{
      "products":[
         {
            "sku":"75103716050",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         },
         {
            "sku":"99893600000",
            "sceneId":null
         },
         {
            "sku":"74895100000",
            "sceneId":"614b3e16d7bb008cbec58cb6"
         },
         {
            "sku":"75051219065",
            "sceneId":"614c8c355d0a6b36fe5ab366"
         }
      ]
   }
}